module.exports = __webpack_public_path__ + "img/ad_2.cced5584.jpg";